import React from "react";
import useFormComponentState from "../../../../common/forms/useFormComponentState";
import { SearchCriterion } from "../common/SearchCriterion";
import RadioButtons from "./RadioButtons";
import { radioChoicesType, requiredRolesType } from "../../../../common/types/search/search";

interface RadioButtonTabsCriterionProps {
	criterionKey: string;
	label: string;
	prefix?: string;
	quickSearch?: boolean;
	requiredRoles?: requiredRolesType;
	choices: radioChoicesType;
}

export function RadioButtonTabsCriterion({
	criterionKey,
	label,
	prefix,
	quickSearch = false,
	requiredRoles,
	choices,
}: RadioButtonTabsCriterionProps) {
	const { currentInput, onInputChangeAndSearch } =
		useFormComponentState(criterionKey);

	return (
		<SearchCriterion
			label={label}
			prefix={prefix}
			quickSearch={quickSearch}
			requiredRoles={requiredRoles}
		>
			<div className="criterion tab-criterion grid__col-12">
				<RadioButtons
					label={label}
					choices={choices}
					currentInput={currentInput}
					criterionKey={criterionKey}
					onInputChange={onInputChangeAndSearch}
				/>
			</div>
		</SearchCriterion>
	);
}
